import { render, staticRenderFns } from "./TableLinkList.vue?vue&type=template&id=2d18b010&"
import script from "./TableLinkList.vue?vue&type=script&lang=js&"
export * from "./TableLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports